<template>
  <div class="d-flex flex-column">
    <div class="sub-title">Panelen</div>

    <table class="panel-rows">
      <thead>
        <tr>
          <th class="index">&nbsp;</th>
          <th class="length">&nbsp;</th>
          <th class="width">&nbsp;</th>
          <th class="amount">&nbsp;</th>
          <th class="description" colspan="4">
            Kantafwerking
            <font-awesome-icon id="finish-info-icon" class="font-awesome-icon finish-info" icon="info-circle"/>
            <b-tooltip target="finish-info-icon" variant="secondary" placement="top"><img src="images/kv.png"/></b-tooltip>
          </th>
          <th class="reference">&nbsp;</th>
          <th class="actions">&nbsp;</th>
        </tr>
        <tr>
          <th class="index">&nbsp;</th>
          <th class="length description brackets" :class="{'invisible': hasGrain !== 'lengte'}">
            <div class="brackettop left"></div>
            <div class="bracketside left"></div>
            <div class="bracketside right"></div>
            <div class="brackettop right"></div>
            Nerfricht.
          </th>
          <th class="width description brackets" :class="{'invisible': hasGrain !== 'breedte'}">
            <div class="brackettop left"></div>
            <div class="bracketside left"></div>
            <div class="bracketside right"></div>
            <div class="brackettop right"></div>
            Nerfricht.
          </th>
          <th class="amount">&nbsp;</th>
          <th class="description brackets" colspan="2">
            <div class="brackettop left"></div>
            <div class="bracketside left"></div>
            <div class="bracketside right"></div>
            <div class="brackettop right"></div>
            Lengte
          </th>
          <th class="description brackets" colspan="2">
            <div class="brackettop left"></div>
            <div class="bracketside left"></div>
            <div class="bracketside right"></div>
            <div class="brackettop right"></div>
            Breedte
          </th>
          <th class="reference">&nbsp;</th>
          <th class="actions">&nbsp;</th>
        </tr>
        <tr>
          <th class="index">&nbsp;</th>
          <th class="length">Lengte</th>
          <th class="width">Breedte</th>
          <th class="amount">Aantal</th>
          <th class="checkbox l1">L1</th>
          <th class="checkbox l2">L2</th>
          <th class="checkbox b1">B1</th>
          <th class="checkbox b2">B2</th>
          <th class="reference">Paneelreferentie</th>
          <th class="actions">&nbsp;</th>
        </tr>
      </thead>

      <tbody class="panel-rows-body">
        <tr class="spacer-row"><td colspan="10"></td></tr>
        <app-panel-row
          v-for="panel in panels"
          :panel="panel"
          ref="panel"
          :key="panel.id"
          v-on:upElement="upElement"
          v-on:downElement="downElement"
        />

        <tr class="disabled-panel-row" @click="addRow">
          <td class="index">
            {{ panels.length + 1 }}
          </td>
          <td class="length">
            <input type="number" disabled class="form-control disabled" min="0" placeholder="mm">
          </td>
          <td class="width">
            <input type="number" disabled class="form-control disabled" min="0" placeholder="mm">
          </td>
          <td class="amount">
            <input type="number" disabled class="form-control disabled" min="0">
          </td>
          <td class="checkbox l1">
            <input disabled type="checkbox" class="checkbox-side"/>
            <label></label>
          </td>
          <td class="checkbox l2">
            <input disabled type="checkbox" class="checkbox-side"/>
            <label></label>
          </td>
          <td class="checkbox b1">
            <input disabled type="checkbox" class="checkbox-side"/>
            <label></label>
          </td>
          <td class="checkbox b2">
            <input disabled type="checkbox" class="checkbox-side"/>
            <label></label>
          </td>
          <td class="reference">
            <input type="text" disabled class="form-control disabled" placeholder="">
          </td>
          <td class="actions">
            &nbsp;
          </td>
        </tr>
        <tr class="spacer-row"><td colspan="10"></td></tr>
      </tbody>
    </table>

    <div v-if="showExcel" class="panel-rows mt-3">
      <div class="panel-rows-body">
        <div class="col-md-13 text-center p-0 mt-3 mb-3">
          Snel je panelen invoeren?
          <a @click="uploadExcel" href="#" class="link ml-2">
            <font-awesome-icon class="font-awesome-icon" icon="arrow-circle-up"/>
            Upload een Excel-bestand
          </a>
          <app-upload-excel ref="appUploadExcel"/>
          <font-awesome-icon class="font-awesome-icon action times hideExcel" v-on:click.stop.prevent="hideExcel" icon="times"/>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import { MUTATE_DISABLE_EXCEL_UPLOAD } from '../../../store/types'
  import PanelRow from '@/components/Tool/Panels/PanelRow.vue'
  import UploadExcel from '@/components/Tool/Panels/UploadExcel.vue'

  export default {
    data() {
      return {
        showExcel: true
      }
    },
    components: {
      'app-panel-row': PanelRow,
      'app-upload-excel': UploadExcel
    },
    computed: {
      panels() {
        return !this.$store.getters.panels ? [] : this.$store.getters.panels
      },
      product() {
        return this.$store.getters.materialProduct
      },
      side1() {
        return this.$store.getters.materialSide1
      },
      hasGrain() {
        let top = !this.side1 ? this.product : this.side1
        return top && top.grain && top.grain !== 'Geen' ? top.grain.toLowerCase() : false
      }
    },
    methods: {
      addRow() {
        let id = this.panels.length + 1

        this.panels.push({ id: id, length: null, width: null, amount: null, l1: false, l2: false, b1: false, b2: false, reference: null, valid: null })

        this.$nextTick(function() {
          this.$refs.panel[id - 1].$refs.length.focus()
        })
      },
      upElement(target, panel) {
        if (this.$refs.panel[(panel.id - 1) - 1]) {
          this.$refs.panel[(panel.id - 1) - 1].$refs[target].focus()
        }
      },
      downElement(target, panel) {
        if (this.$refs.panel[(panel.id - 1) + 1]) {
          this.$refs.panel[(panel.id - 1) + 1].$refs[target].focus()
        } else {
          // We need to add a row!
          this.addRow()
        }
      },
      uploadExcel() {
        this.$refs.appUploadExcel.showModal()
      },
      hideExcel() {
        this.$store.commit(MUTATE_DISABLE_EXCEL_UPLOAD, true)
        this.showExcel = false
      }
    },
    mounted() {
      this.showExcel = this.$store.getters.material.disableExcelUpload === true ? false : true
    },
    updated() {
      this.showExcel = this.$store.getters.material.disableExcelUpload === true ? false : true
    }
  }
</script>

<style lang="scss" scoped>
</style>
